import { useState } from 'react';
import styled from 'styled-components';
import FaqMenuBar from '~/components/FaqMenuBar';
import FaqQuestions from '~/components/FaqQuestions';
import { CustomHead } from '~/components/Head';
import StaticPageLayout from '~/components/layouts/StaticPageLayout';
import faqs from '~/data/faq';
import theme from '~/styles/styledComponentsTheme';
import React from 'react';
import dynamic from 'next/dynamic';
import Typography from '~/atoms/Typography';
import { GetServerSideProps, GetStaticProps } from 'next';
import CardGrid from '~/components/CardGrid';
import { CARD_SECTION_ARTICLE, CONTENT_GRID_CONTENT_TYPE_VIDEO } from '~/globals';
import publicService from '~/api/services/publicContentService';
import { AnyAaaaRecord } from 'dns';

const { getSlugContent } = publicService;
const { getMostRecentArticles } = articleService;

import VideoPlayer from '~/components/VideoPlayer';
import VideoPlayback from '~/components/VideoPlayer/VideoPlayback';
import { Flex } from '~/utils/LSTVUtils';
import { CtaColorScheme, CtaLink } from '~/components/cta/regular';
import * as S from '~/components/pages/VideoPage/index.styles';
import { ArticleCard } from '~/components/cards/ArticleCard';
import { formatDate } from '~/utils/date';
import articleService from '~/api/services/articleService';
import { VidContainer } from '~/pages/live';

const TopImage = styled.img`
  margin: 0 auto;
  width: 60%;
  text-align: center;
  position: relative;
  display: block;

  @media ${theme.breakpoints.isMobile} {
    width: 100%;
  }
  padding-bottom: 40px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;

  @media ${theme.breakpoints.laptop} {
    flex-direction: row;
    margin-top: 30px;
  }
`;

const Paragraph = styled.div`
  font-size: 1.4rem;
  line-height: 1.7rem;
  width: 60%;
  margin: 0 auto;

  @media ${theme.breakpoints.isMobile} {
    margin-bottom: 25px;
    width: 100%;
  }

  a {
    color: blue;
  }
`;

const ParagraphHeader = styled(Paragraph)`
  text-decoration: underline;
  font-weight: bold;
`;

const Title = styled.div`
  font-size: 1.5rem;
  line-height: 1.7rem;
  font-weight: bold;

  margin-bottom: 25px;

  @media ${theme.breakpoints.isMobile} {
    margin-bottom: 25px;
  }
`;

export const StyledFaqQuestions = styled(FaqQuestions)`
  width: 100%;

  @media ${theme.breakpoints.laptop} {
    margin-left: 46px;
  }
`;

export const Channel = styled.div`
  img {
    max-width: 100px;
  }

  padding: 5px;
`;

export const ChannelLineup = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const ItemList = styled.ul`
  margin-left: 20px;
  list-style-type: '-   ';
  font-size: 12px;
  line-height: 1.6em;
  padding: 0 1em;

  li {
    font-size: 1.4rem;
    line-height: 1.7rem;

    a {
      color: blue;
    }
  }
`;

export const Bold = styled.span`
  font-weight: bold;
  //background: #fff072;
  //border-radius: 5px;
  //padding: 5px;
  font-size: 1.4rem;
  line-height: 1.6rem;
`;

const VideoFrame = styled.div`
  width: 70%;
  margin: 0 auto;
  padding: 20px;

  @media ${theme.breakpoints.isMobile} {
    width: 100%;
    padding: 20px 0 20px 0;
  }
`;

const Player = dynamic(() => import('react-hls-player'), { ssr: false });

const desc = 'Welcome to Unconditional. A new series from Love Stories TV where we tell the stories of inspiring couples who have overcome the greatest odds to be together.';

const UnconditionalPage = (props) => {
  return (
    <>
      <CustomHead
        title='Watch Unconditional: A New series from Love Stories TV'
        titleOg={'Watch Unconditional: A New series from Love Stories TV'}
        description={desc}
        image={'https://cdn.lovestoriestv.com/ext/misc/Chinna%2Berika_thumb02.jpg'}
        url={`/chinna-erica`}
      />
      <StaticPageLayout wideContent headerText='Unconditional: Chinna + Erica'>
        <TopImage src='https://cdn.lovestoriestv.com/ext/misc/Chinna%2Berika_thumb02.jpg' />
        {/*<img src={"https://cdn.lovestoriestv.com/temp/wedding_talk_crkl_key_art_-_16x9__now_.jpg"}/>*/}
        {/*<Flex direction="row" align="center" justifyContent="center">*/}
        {/*  <CtaLink to={'https://www.chickensouptv.com/watch/bf2dfa0c-e783-4382-8100-fff469222bda/wedding-talk/sparkly-exits'} $colorScheme={CtaColorScheme.Dark} caption={'Watch Now'} />*/}
        {/*</Flex>*/}
        <Paragraph>{desc}</Paragraph>
        <br />
        <Paragraph>Episode 2 showcases the incredible journey of Chinna and Erica, whose love grew even stronger after
          Chinna&apos;s life-altering brain injury. Prepare to be amazed as Chinna defies all odds, transforming from a
          near-death experience to an Ultimate Ninja Warrior.

        </Paragraph>
        <br />
        <Paragraph>
          <VidContainer>
            <VideoPlayback
              noContainer={true}
              uniqueId='thumbnailChooserVideoPlayback'
              videoType='jwplayer'
              videoWidth='100%'
              mediaID={'WTc6zp7c'}
              isMuted={true}
              withPreRoll={false}
              showLoadingMessage={false}
              isAutoPlay={false}
            />
          </VidContainer>
        </Paragraph>
        <Paragraph>
          <br />
          Unconditional is streaming on The Love Stories TV Channel. To watch, add the <a rel='noreferrer'
                                                                                          target={'_blank'}
                                                                                          href={'https://sling.com'}>Sling</a> app
          (free - no subscription
          required) to your TV. Go to Guide and navigate to Love Stories TV. See our full list of streamers, including
          international viewing options,  <a href={'https://lovestoriestv.com/live'} rel='noreferrer' target={'_blank'}>here</a>.

        </Paragraph>
        <br />
        <Paragraph>
          Do you or a loved one have a story that we should tell on an upcoming episode of Unconditional? <a
          target={'_blank'} rel='noreferrer'
          href='https://docs.google.com/forms/d/e/1FAIpQLSf4pBjcdsJdHVJZe-YVSdNwMbzd2SzfVeHW1Gb-FX4K3aG1Ow/viewform?usp=sf_link'>Get
          in touch with us</a>.
        </Paragraph>

      </StaticPageLayout>
    </>
  );
};

interface Props {
  valid: true;
  videos: any;
  articles: any;
}


export default UnconditionalPage;
